module.exports = __webpack_public_path__ + "static/media/denea-marable.36864c5f.jpeg";